module.exports = __webpack_public_path__ + "bd-intro.png?02b8a4bd417649355968240db20b19e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bd-intro.png
// module id = 143
// module chunks = 0